import { useQuery } from "@apollo/client";
import { CurrentUserOrganizationsDocument } from "../../__generated__/graphql";
import { useAuth } from "../useAuth";

export default function useCurrentUserOrganizations() {
  const { userId } = useAuth();
  const { data, loading, error } = useQuery(CurrentUserOrganizationsDocument, {
    fetchPolicy: "cache-and-network", // Ensure we always get fresh data
    skip: !userId, // Only fetch if userId is available
  });

  // isPartOfOrganization will be undefined when loading or data is not available
  // true when user is part of an organization, false otherwise
  const isPartOfOrganization = data?.organizations
    ? data.organizations.some((organization) =>
        organization?.users.some((user) => user?.userId === userId)
      )
    : undefined;

  return { data, loading, error, isPartOfOrganization };
}
